import styles from './MemberExpanded.module.css';

function MemberExpanded({ member, onClose }) {
  return (
    <>
      <button className={styles.closeBtn} onClick={onClose}>✕</button>
      <div className={styles.expandedInfo}>
        <p className={styles.name}>{member.name}</p>
        <p className={styles.role}>{member.role}</p>
        <p className={styles.about}>{member.about}</p>
      </div>
    </>
  );
}
export default MemberExpanded;